import React from "react";
import authApi from "@/services/auth-api";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LOGIN_FAIL, LOGIN_SUCCESS, SET_MESSAGE } from "@/actions/types";
import { getErrorMessage } from "@/utilities/error";
import { useMutation } from "@tanstack/react-query";
import { useSessionStorageState } from "ahooks";

const LoginBySession = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [params] = useSearchParams()
	const [
		_,
		setIsLoginBySession,
	] = useSessionStorageState("is_login_by_session", {
		defaultValue: false,
	});
	const session_id = params.get("session_id");

	const validateMutation = useMutation({
		mutationFn: async (session_id: string) => {
			const data = await authApi.validateLoginSession(session_id).then((response) => response.data)
			const userData = {
				token: data.token,
				user: data.user,
			};
			localStorage.setItem("user", JSON.stringify(userData));
			localStorage.setItem("isHyperAdminLogin", false);
			setIsLoginBySession(true);

			dispatch({
				type: LOGIN_SUCCESS,
				payload: {
					user: userData,
				},
			});

			const redirectUrl = new URL(data.redirect_url);
			const historyState = redirectUrl.searchParams.get('history_state')
			if (historyState) {
				let decodedHistoryState = decodeURIComponent(historyState)
				if (historyState) {
					const historyStateObj = JSON.parse(decodedHistoryState);
					navigate(
						redirectUrl.pathname, {
						state: historyStateObj
					})
				}
			} else {
				window.location.href = data.redirect_url;
			}
		},
		onError: (error) => {
			dispatch({
				type: LOGIN_FAIL,
			});
			dispatch({
				type: SET_MESSAGE,
				payload: getErrorMessage(error),
			});
		},
	});

	useEffect(() => {
		if (session_id) {
			validateMutation.mutate(session_id);
		}
	}, [session_id]);


	return <div className="d-flex justify-content-center align-items-center h-100">
		{
			validateMutation.isLoading && <div>Authenticating ...</div>
		}
		{
			validateMutation.isError && <div >
				{/* {getErrorMessage(validateMutation.error)} */}
			</div>
		}
		{
			validateMutation.isSuccess && <div className="text-center">Authenticated Successfully.<br /> Redirecting....</div>
		}
	</div>
};

export default LoginBySession;